export const STAGES = [
  "New Lead",
  "Contacted",
  "Meeting Scheduled",
  "Qualified",
  "Proposal Sent",
  "Negotiation",
  "Follow-Up",
  "Won",
  "Lost",
  "On Hold",
];

export const STAGE_STYLES = {
  "New Lead": { light: "bg-blue-100 text-blue-900", dark: "dark:bg-blue-950 dark:text-blue-200" },
  "Contacted": { light: "bg-amber-100 text-amber-900", dark: "dark:bg-amber-950 dark:text-amber-200" },
  "Meeting Scheduled": { light: "bg-indigo-100 text-indigo-900", dark: "dark:bg-indigo-950 dark:text-indigo-200" },
  "Qualified": { light: "bg-emerald-100 text-emerald-900", dark: "dark:bg-emerald-950 dark:text-emerald-200" },
  "Proposal Sent": { light: "bg-pink-100 text-pink-900", dark: "dark:bg-pink-950 dark:text-pink-200" },
  "Negotiation": { light: "bg-orange-100 text-orange-900", dark: "dark:bg-orange-950 dark:text-orange-200" },
  "Follow-Up": { light: "bg-sky-100 text-sky-900", dark: "dark:bg-sky-950 dark:text-sky-200" },
  "Won": { light: "bg-green-100 text-green-900", dark: "dark:bg-green-950 dark:text-green-200" },
  "Lost": { light: "bg-red-100 text-red-900", dark: "dark:bg-red-950 dark:text-red-200" },
  "On Hold": { light: "bg-zinc-200 text-zinc-800", dark: "dark:bg-zinc-800 dark:text-zinc-200" },
};

export const CATEGORIES = ["Certification", "Solar", "Training", "Consulting", "Cybersecurity", "Other"];

export const SOURCES = [
  "LinkedIn", "Website", "Facebook", "Instagram", "Google Ads",
  "Referral", "Email Campaign", "Manual", "CSV",
];

export const LEAD_TYPES = ["Company", "Individual"];

export const PRIORITIES = ["Hot", "High", "Medium", "Low"];

export const PRIORITY_STYLES = {
  Hot: "bg-red-100 text-red-900 dark:bg-red-950 dark:text-red-200",
  High: "bg-orange-100 text-orange-900 dark:bg-orange-950 dark:text-orange-200",
  Medium: "bg-blue-100 text-blue-900 dark:bg-blue-950 dark:text-blue-200",
  Low: "bg-zinc-200 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
};

export const CUSTOMER_STATUSES = ["Active", "Inactive", "Renewal Due"];

export const CUSTOMER_STATUS_STYLES = {
  Active: "bg-emerald-100 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-200",
  Inactive: "bg-zinc-200 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
  "Renewal Due": "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200",
};

export const ROLES = [
  { value: "master_admin", label: "Master Admin" },
  { value: "admin", label: "Admin / Sales Manager" },
  { value: "lead_generator", label: "Lead Generation Executive" },
  { value: "sales_executive", label: "Sales Executive" },
];

export const ROLE_LABEL = Object.fromEntries(ROLES.map((r) => [r.value, r.label]));
